export default __webpack_public_path__ + "static/bg-pau-02-ad8340798483f607919eb3846759bf7c.jpg";